import { getSiteProps } from "@/utils/siteProps";

import { qualification } from "./highestQualification/script";
import { location } from "./location/script";
import { nationality } from "./nationality/script";
import {
  employmentType,
  gender,
  lookingFor,
  noticePeriod,
  percentage,
} from "./pillData/script";
import { prefLocation } from "./preferedLocation/script";
import { university } from "./university/script";

// import { workVisa } from "./workVisa/script";

export const popularList = (channel = "rexmonster") => {
  return { location: location[channel as keyof typeof location], gender };
};

export default function (hostname: string) {
  let channel = getSiteProps(hostname)?.["site_map"] || "rexmonster";

  return {
    location: location[channel as keyof typeof location],
    nationality: nationality[channel as keyof typeof nationality],
    prefLocation: prefLocation[channel as keyof typeof prefLocation],
    qualification: qualification[channel as keyof typeof qualification],
    university: university[channel as keyof typeof university],
    noticePeriod,
    percentage,
    gender,
    employmentType,
    lookingFor,
  };
}
